<template lang="pug">
div
  div(v-if="$route.query.dimension_item_id")
    DimensionItem(:dimension_item_id="$route.query.dimension_item_id")
  div(v-else)
    UiCardSection
      UiStack
        UiStackItem(fill)
          .ui-card-section-title {{ $t("companies.tabs.dimensions") }}
        UiStackItem
          UiButton(
            variant="primary"
            @click="exportDimensions()"
            icon="FileDownload"
          ) {{ $t("companies.dimensions.export_to_csv") }}
    UiCardSection
      RestTable(
        embed
        :headers="headers"
        :fetch-handler="getData"
        :initial-filters="initialFilters"
        :namespace="tableNamespace"
        ref="companyDimensionsTable"
      )
        template(#filters="{ filters, updateFilters }")
          UiStack
            UiStackItem(fill)
              UiFormGroup(
                :label="$t('companies.dimensions.name')"
                label-for="dimension-input"
              )
                UiInput#dimension-input(
                  :modelValue="filters.search"
                  type="search"
                  @update:modelValue="updateFilters({ search: $event })"
                )
            UiStackItem(fill)
              UiFormGroup(
                :label="$t('companies.dimensions.item')"
                label-for="dimension-item-input"
              )
                UiInput#dimension-item-input(
                  :modelValue="filters.item"
                  type="search"
                  @update:modelValue="updateFilters({ item: $event })"
                )
            UiStackItem(fill)
              UiFormGroup(
                :label="$t('companies.account_keyword.keywords')"
                label-for="keyword-input"
              )
                UiInput#keyword-input(
                  :modelValue="filters.search_keyword"
                  type="search"
                  @update:modelValue="updateFilters({ search_keyword: $event })"
                )
        template(#cell:not_suggest_dimension="{ item }")
          UiCheckbox(
            v-model="item.not_suggest_dimension"
            switch
            @update:modelValue="changeNotSuggestDimension(item)"
          )
        template(#cell:data_priority="{ item }")
          UiMultiselect(
            v-model="item.data_priority"
            :options="dataPriorityOptions"
            label="text"
            @update:modelValue="changeDataPriority(item)"
            :canClear="false"
            :canDeselect="false"
          )
        template(#cell:not_suggest="{ item }")
          UiCheckbox(
            v-model="item.not_suggest"
            switch
            @update:modelValue="changeNotSuggest(item)"
          )
        template(#cell:name_as_keyword="{ item }")
          UiCheckbox(
            v-model="item.name_as_keyword"
            switch
            @update:modelValue="changeNameAsKeyword(item)"
          )
        template(#cell:if_account="{ item }")
          UiTagsInput.tags-field(
            searchable
            createOption
            hideSelected
            mode="tags"
            v-model="item.if_account"
            :placeholder="$t('companies.dimensions.accounts_prompt')"
            :invalidTagText="$t('companies.dimensions.invalid_account')"
            @update:modelValue="changeIfAccount(item)"
            :tagValidator="ifAccountValidator"
            :canClear="false"
          )
            template(v-slot:invalid-feedback)
              | You must provide at least 3 tags and no more than 8
        template(#cell:keywords="{ item }")
          UiTagsInput.tags-field(
            searchable
            createOption
            hideSelected
            mode="tags"
            v-model="item.keywords"
            :placeholder="$t('companies.dimensions.keywords_prompt')"
            @update:modelValue="changeKeywords(item)"
            :canClear="false"
          )
        template(#cell:default_dimension_item="{ item }")
          UiCheckbox(
            v-model="item.default"
            switch
            @update:modelValue="changeDefaultDimensionItem(item)"
          )
        template(#cell:row_custom_details="{ item }")
          UiMultiselect(
            v-model="item.row_custom_details"
            :options="rowCustomDetailsOptions"
            @update:modelValue="changeRowCustomDetails(item)"
            :canClear="false"
            :canDeselect="false"
            label="text"
          )
        template(#cell:approver_id="{ item }")
          RouterLink(
            :to="{ ...$route, query: { ...$route.query, dimension_item_id: item.id } }"
            label="item.name"
          ) Approvers
</template>

<script>
import router from "@/router";
import ApiCompanyDimensions from "@/api/companyDimensions.js";
import DimensionItem from "@/views/DimensionItems/show.vue";

export default {
  components: {
    DimensionItem,
  },

  data() {
    return {
      initialFilters: {
        item: "",
        search_keyword: "",
      },
      headers: [
        {
          key: "dimension_name",
          label: "Dimension",
        },
        {
          key: "if_account",
          label: "Set dimension if account",
        },
        {
          key: "not_suggest_dimension",
          label: "Don't suggest dimension",
        },
        {
          key: "name_as_keyword",
          label: "Name as keyword",
        },
        {
          key: "data_priority",
          label: "Data priority",
        },
        {
          key: "name",
          label: "Dimension Item",
        },
        {
          key: "created_at",
          label: "Created",
          cellClass: "text-nowrap",
        },
        {
          key: "not_suggest",
          label: "Don't suggest item",
        },
        {
          key: "keywords",
          label: "Keywords",
        },
        {
          key: "default_dimension_item",
          label: "Default",
        },
        {
          key: "row_custom_details",
          label: "Custom Details",
        },
        {
          key: "approver_id",
          label: "Approvers",
        },
      ],
      dataPriorityOptions: [
        { value: "default", text: "Prioritise row based data" },
        { value: "finvoice_first", text: "Prioritise general invoice data" },
        { value: "finvoice_only", text: "Only use general invoice data" },
        { value: "keywords_only", text: "Only use keywords" },
      ],
      rowCustomDetailsOptions: [
        { value: "", text: "Not used" },
        { value: "apartment", text: "Apartments" },
      ],
    };
  },

  computed: {
    tableNamespace() {
      return "dimensions";
    },
  },

  methods: {
    getData(params, config) {
      return ApiCompanyDimensions.fetchDimensions(
        this.$route.params.id,
        params,
        config,
      ).then((resp) => {
        return {
          items: resp.data.dimensions,
          meta: resp.data.meta,
        };
      });
    },
    exportDimensions() {
      ApiCompanyDimensions.exportDimensions(
        this.$route.params.id,
        this.$refs.companyDimensionsTable.getTableFilters(this.tableNamespace),
      )
        .then((resp) => {
          let fileURL = window.URL.createObjectURL(new Blob([resp.data]));
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", `cost_centers_list.csv`);
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((e) => {});
    },
    changeNotSuggestDimension(item) {
      this.saveDimension(item.id, {
        dimension: { not_suggest_dimension: item.not_suggest_dimension },
      });
    },
    changeDefaultDimensionItem(item) {
      this.saveDimension(item.id, {
        dimension: { default: item.default },
      });
    },
    changeNotSuggest(item) {
      this.saveDimension(item.id, {
        dimension: { not_suggest: item.not_suggest },
      });
    },
    changeNameAsKeyword(item) {
      this.saveDimension(item.id, {
        dimension: { name_as_keyword: item.name_as_keyword },
      });
    },
    changeRowCustomDetails(item) {
      this.saveDimension(item.id, {
        dimension: { row_custom_details: item.row_custom_details },
      });
    },

    changeDataPriority(item) {
      this.saveDimension(item.id, {
        dimension: { data_priority: item.data_priority },
      });
    },

    changeIfAccount(item) {
      this.saveDimension(item.id, {
        dimension: { if_account: item.if_account },
      });
    },

    changeKeywords(item) {
      this.saveDimension(item.id, { dimension: { keywords: item.keywords } });
    },

    saveDimension(id, params) {
      ApiCompanyDimensions.updateDimension(
        this.$route.params.id,
        id,
        params,
      ).then((resp) => {
        this.$refs.companyDimensionsTable.fetchData();
      });
    },

    ifAccountValidator(account) {
      return (
        !isNaN(parseInt(account)) && account.length > 3 && account.length < 6
      );
    },
    goBack() {
      router.push("/companies");
    },
  },
};
</script>

<style lang="scss" scoped>
.tags-field {
  width: 320px;
}
</style>
